module.exports = __webpack_public_path__ + "static/media/trans-r-en.feb7999a.png";